import { createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import _ from "lodash";
import zxTitleUrl from "@/assets/img/pc/homePage/information-title.png";
import { getArticleList } from "@/api/common";
// components
import SwiperBox from "./swiperBox.vue";
import NewsList from "@/components/common/news-list.vue";
import { useRaceNews } from "@/hooks/race-news";
export default defineComponent({
  name: "MInformation",
  setup() {
    // 组件状态
    const state = reactive({
      activeIndex: 1,
      swiperSetInfo: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 0,
        key: "wj-three-pc",
        type: "three-container",
        slideList: []
      }
    });
    const {
      newsState,
      switchNewsFct,
      clickNewsItemFct
    } = useRaceNews();
    const router = useRouter();
    const onActiveChange = active => {
      state.activeIndex = active;
      switchNewsFct({
        value: active
      });
    };
    const getSwiperList = () => {
      const params = {
        code: ["match_center_hot_news_banner"],
        pageRows: 5
        // isRecommend: 1,
      };

      getArticleList(params).then(res => {
        if (res.code === 0) {
          state.swiperSetInfo.slideList = res.data.list || [];
        }
      }).catch(err => console.log(err));
    };
    getSwiperList();
    return () => {
      return _createVNode("div", {
        "class": "information-box pc-information"
      }, [_createVNode("div", {
        "class": "title-box",
        "id": "hot-news"
      }, [_createVNode("img", {
        "class": "title",
        "src": zxTitleUrl
      }, null)]), _createVNode("div", {
        "class": "content"
      }, [_createVNode(SwiperBox, {
        "swiperSetInfo": state.swiperSetInfo
      }, null), _createVNode("div", {
        "class": "news-list"
      }, [_createVNode("div", {
        "class": "tabs"
      }, [_createVNode("div", {
        "class": "left"
      }, [_.map(newsState.newsTabData, item => {
        return _createVNode("div", {
          "onClick": () => {
            onActiveChange(item.type);
          },
          "class": ["tabs-item", item.type === state.activeIndex ? "active" : "hidden"]
        }, [item.text]);
      })]), _createVNode("div", {
        "class": "more-btn hidden",
        "onClick": () => router.push("/race-news")
      }, [_createVNode("img", {
        "src": require(`@/assets/img/pc/homePage/more-btn.png`)
      }, null)])]), _createVNode(NewsList, {
        "isHome": true,
        "newsData": newsState.newsData,
        "showType": false,
        "onClickNewsItem": clickNewsItemFct
      }, null)])])]);
    };
  }
});